module.exports = __webpack_public_path__ + "static/media/eye.9f6345d6.svg";